import { Component, forwardRef, ElementRef, Renderer2, OnDestroy, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'vb-checkbox-group',
  template: `<ng-content></ng-content>`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxGroupComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class CheckboxGroupComponent implements ControlValueAccessor, OnDestroy {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;

  public disabled: boolean;

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  addOrRemove(value: any) {
    if (this.contains(value)) {
      this.remove(value);
    } else {
      this.add(value);
    }
  }

  contains(value: any): boolean {
    if (this.modelValue instanceof Array) {
      return this.modelValue.indexOf(value) > -1;
    } else if (this.modelValue) {
      return this.modelValue === value;
    }

    return false;
  }

  private add(value: any) {
    if (!this.contains(value)) {
      if (this.modelValue instanceof Array) {
        //this.modelValue.push(value);
        this.modelValue = [...this.modelValue, ...[value]];
      } else {
        this.modelValue = [value];
      }
      this.onChange(this.modelValue);
    }
  }

  private remove(value: any) {
    const index = this.modelValue.indexOf(value);
    if (!this.modelValue || index < 0) {
      return;
    }
    this.modelValue = this.modelValue.filter((m) => m !== value);
    //this.modelValue.splice(index, 1);
    this.onChange(this.modelValue);
  }

  ngOnDestroy(): void {
    if ($(this.elementRef.nativeElement)) {
      $(this.elementRef.nativeElement).remove();
    }
  }
}
